<template>
  <div class="menu">
    <nav class="navbar navbar-expand-md navbar-bytebank" v-if="menuIsVisible">
      <ul class="navbar-nav mr-auto">
        <li
          v-for="menu in menus"
          :key="menu.icon"
          :class="`nav-item ${listItemVisible(menu.visible)}`"
        >
          <router-link
            v-if="disableButton(menu.visible, menu.id, disableMenuProcesso, anableButtonEditar)"
            v-tooltip.auto-start="menu.title"
            :id="menu.id" :title="menu.title"
            class="nav-link"
            :to="menu.path">
            <i :class="menu.icon" :style="menu.styleTitulo"></i>
          </router-link>
        </li>
        <li class="nav-item">
          <button
            v-if="disableButton(true, 'incluirDocumentos', disableMenuProcesso, anableButtonEditar)"
            type="button"
            class="nav-link pure-button"
            v-tooltip.auto-start="'Incluir Documentos'"
            id="incluirDocumentos" :title="'Incluir Documentos'"
            @click.prevent="openDocumentoExterno()"
          >
            <i class="fa fa-book fa-1-7x" style="color: #4a75b5;"></i>
          </button>
        </li>
        <li class="nav-item">
          <button
            v-if="resgatarProtocoloIsVisible"
            type="button"
            class="nav-link pure-button"
            v-tooltip.auto-start="'Resgatar Protocolo'"
            id="resgatarProtocolo" :title="'Resgatar Protocolo'"
            @click.prevent="openResgatarProtocolo()"
          >
            <i class="fa fa-exchange fa-1-7x" style="color: #4a75b5;"></i>
          </button>
        </li>
      </ul>
    </nav>

    <modal ref="listaDocumento" width="750px" height="">
      <template v-slot:header>
        <div class="modal-header">
          <h4 class="text-primary m-3">Documentos Externos</h4>
          <i class="fa fa-times fa-1-7x m-2 link" @click="$refs.listaDocumento.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-right text-sm-center">
          <button type="button" class="btn btn-outline-info m-1" @click.prevent="() => {
            $router.push({ path: `/elaboracao/${numeroProcesso}/documento`, query: { disableMenuProcesso: disableMenuProcesso, tramitado: isTramitado } })
            $store.commit('MUT_DOCUMENTO', { numeroProtocolo: numeroProcesso })
            $refs.listaDocumento.closeModal()
          }">Novo Documento</button>
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.listaDocumento.closeModal()">Cancelar</button>
          <listaDocumento :numeroProcesso="numeroProcesso" v-on:fechar-modal="$refs.listaDocumento.closeModal()"/>
        </div>
      </template>
    </modal>

    <modal ref="resgatarProtocolo" width="750px" height="500px">
      <template v-slot:header>
        <div class="modal-header">
          <alert-comp :key="alert.key" :msg="alert" width="75"/>
          <h4 class="text-primary m-3">Resgatar Protocolo</h4>
          <i class="fa fa-times fa-1-7x m-2 link" @click="$refs.resgatarProtocolo.closeModal()" />
        </div>
      </template>

      <template v-slot:body>
        <div class="modal-body text-md-center">
          <span>
            <h5>
              <span class="badge badge-primary" v-if="instancia.apensadoEm">
                O protocolo está apensado no: {{ formatarProtocolo(instancia.apensadoEm) }}
              </span>
              <span class="badge badge-primary" v-if="instancia.anexadoEm">
                O protocolo está anexado no: {{ formatarProtocolo(instancia.anexadoEm) }}
              </span>
              <span class="badge badge-primary" v-if="instancia.remocao">
                Não será possivel fazer a ação, pois o protocolo está eliminado
              </span>
            </h5>
          </span>
          <p v-if="resgatarIsVisible()">O protocolo está em uma estrutura inativa, gostaria de atribuir ele a você?</p>
          <button v-if="resgatarIsVisible()" type="button" class="btn btn-outline-info m-1" @click.prevent="() => { resgatarProtocolo() }">Confirmar</button>
          <button type="button" class="btn btn-outline-danger m-1" @click.prevent="$refs.resgatarProtocolo.closeModal()">Cancelar</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VirtusRepositoryService from '@/services/VirtusRepositoryService'
import VirtusService from '@/services/VirtusService'
import EstruturaService from '@/services/EstruturaService'

import { componentIsVisible, rules } from '@/uteis/action/permissao'
import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'

import modal from '@/components/shared/Modal.vue'
import listaDocumento from '@/components/documento/ListaDocumento.vue'
import alertComp from '@/components/alert/AlertComp'

export default {
  data () {
    return {
      data: Date.now(),
      instancia: {},
      isInativaEstrutura: false,
      isResgatado: false,
      alert: {
        type: '',
        texto: '',
        key: true
      }
    }
  },
  props: {
    numeroProcesso: { type: String, required: false },
    disableMenuProcesso: { type: Boolean, required: false, default: false },
    anableButtonEditar: { type: Boolean, required: false, default: false }
  },

  components: {
    modal,
    listaDocumento,
    alertComp
  },

  methods: {
    openDocumentoExterno () {
      this.service.documentoExterno(this.numeroProcesso, this.$store.getters.getDadosSessao.sessao.login).then(resp => {
        if (resp.data.length === 0) {
          this.$router.push({ path: `/elaboracao/${this.numeroProcesso}/documento`, query: { disableMenuProcesso: this.disableMenuProcesso, tramitado: this.isTramitado } })
          this.$store.commit('MUT_DOCUMENTO', { numeroProtocolo: this.numeroProcesso })
        } else {
          this.$refs.listaDocumento.openModal()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    openResgatarProtocolo () {
      this.$refs.resgatarProtocolo.openModal()
    },
    getInstancia () {
      this.service.getInstanciaFluxoByNumeroProcesso(this.numeroProcesso).then(resp => {
        if (resp) {
          const instancia = resp
          this.instancia = resp
          if (this.instancia.publicacaoProcesso) {
            this.getEstruturasInativas(`${instancia.ultimaTramitacao.destino.identificador},${instancia.ultimaTramitacao.destino.participantePai.identificador}`)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getEstruturasInativas (participantes) {
      this.estruturaService.getEstruturasInativas({
        offset: 1,
        range: 1,
        'participante.identificador': participantes
      }).then(this.checkEstruturaInativa).catch(err => {
        console.log(err)
      })
    },

    checkEstruturaInativa (resp) {
      this.isInativaEstrutura = resp.data.data ? resp.data.data.length !== 0 : false
    },

    disableButton: (visible, id, disableMenuProcesso = false, anableButtonEditar = false) => {
      var disable = !disableMenuProcesso && visible
      var anableEditar = anableButtonEditar && id === 'editarProtocolo'

      return disable || anableEditar
    },

    listItemVisible: (isVisible) => {
      return isVisible ? '' : 'm-0'
    },

    resgatarIsVisible () {
      return !(this.instancia.apensadoEm || this.instancia.anexadoEm || this.instancia.remocao || this.isResgatado)
    },

    isVisibleEditarProtocolo: (isVisible, isTipoProcesso, isTramitado, isSistemico = false) => {
      const { EDITAR_PROTOCOLO_TRAMITADO, ACESSAR_EDITAR_PROTOCOLO } = rules

      if (isSistemico) {
        return false
      }

      if (isTramitado && componentIsVisible(EDITAR_PROTOCOLO_TRAMITADO)) {
        return true
      }

      if (isTramitado && isTipoProcesso) {
        return false
      }

      if (isVisible) {
        return componentIsVisible(ACESSAR_EDITAR_PROTOCOLO)
      }

      return false
    },

    isVisibleVolume: (isVisible, isTipoProcesso) => {
      const { ACESSAR_VOLUME } = rules
      if (isVisible && !isTipoProcesso) {
        return true
      }

      if (isVisible && isTipoProcesso) {
        return componentIsVisible(ACESSAR_VOLUME)
      }

      return false
    },

    autocompletePath () {
      let path = ''

      if (this.disableMenuProcesso) {
        path += '&disableMenuProcesso=true'
      }

      if (this.isTramitado !== undefined) {
        path += `&tramitado=${this.isTramitado}`
      }

      return path
    },

    resgatarProtocolo () {
      var dadosSessao = this.$store.getters.getDadosSessao.sessao
      if (parseInt(this.instancia.ultimaTramitacao.destino.identificador) === dadosSessao.idDepartamento) {
        this.alert = {
          type: 'warning',
          texto: 'Não pode resgatar um protocolo do mesmo departamento',
          key: !this.alert.key
        }
        return
      }

      this.service.resgatarProtocolo(this.instancia, dadosSessao).then(() => {
        this.alert = {
          type: 'success',
          texto: 'O protocolo foi atribuído com Sucesso e encontra-se no Setor',
          key: !this.alert.key
        }
        this.isResgatado = true
      }).catch(() => {
        this.alert = {
          type: 'warning',
          texto: 'Aconteceu algum erro ao resgatar o protocolo',
          key: !this.alert.key
        }
      })
    },

    formatarProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    }
  },

  computed: mapState({
    menuIsVisible: (state) => state.isVisible.menu === undefined ? true : state.isVisible.menu,
    resgatarProtocoloIsVisible () {
      const { RESGATAR_PROTOCOLO_ARQUIVADO } = rules

      if (this.isResgatado) {
        return false
      }

      if (!this.isInativaEstrutura) {
        return false
      }

      if (this.instancia.remocao) {
        return false
      }

      if (this.instancia.atributos.arquivado) {
        return componentIsVisible(RESGATAR_PROTOCOLO_ARQUIVADO)
      }

      return true
    },
    menus (state) {
      return [
        {
          icon: 'fa fa-link fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/apensar?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Apensar',
          id: 'apensar',
          visible: true
        },
        {
          icon: 'fa fa-files-o fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/elaboracao/manter?numeroProcesso=${this.numeroProcesso}&modelo=true${this.autocompletePath()}`,
          title: 'Utilizar Modelo',
          id: 'utilizarModelo',
          visible: state.isVisible.protocoloTipoProcesso ? componentIsVisible(rules.ACESSAR_USAR_MODELO) : true
        },
        {
          icon: 'fa fa-arrow-circle-o-right fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/elaboracao/tramite?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Tramitar',
          id: 'tramitar',
          visible: true
        },
        {
          icon: 'fa fa-pencil-square-o fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/elaboracao/manter?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Editar Protocolo',
          id: 'editarProtocolo',
          visible: this.isVisibleEditarProtocolo(state.isVisible.editarProtocolo, state.isVisible.protocoloTipoProcesso, this.isTramitado, state.isVisible.isSistemico)
        },
        {
          icon: 'fa fa-folder-open-o fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/virtus/visualizadorProcesso?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Visualizar Processo',
          id: 'visualizarProcesso',
          visible: true
        },
        {
          icon: 'fa fa-archive fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/volume?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Volume',
          id: 'volume',
          visible: this.isVisibleVolume(state.isVisible.volume, state.isVisible.protocoloTipoProcesso)
        },
        {
          icon: 'fa fa-paperclip fa-1-7x',
          styleTitulo: 'color: #4a75b5;',
          path: `/anexar?numeroProcesso=${this.numeroProcesso}${this.autocompletePath()}`,
          title: 'Anexar',
          id: 'anexar',
          visible: state.isVisible.anexar
        }
      ]
    }
  }),

  created () {
    this.virtusRepositoryService = new VirtusRepositoryService()
    this.estruturaService = new EstruturaService()
    this.service = new VirtusService()

    this.isTramitado = this.$route.query.tramitado
    this.buscaGeral = this.$route.query.buscaGeral

    if (this.buscaGeral) {
      this.getInstancia()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/estiloGlobal.scss";

.menu {
  position: absolute;
}
.navbar {

  .navbar-bytebank a {
    color: #fff;
  }
  .navbar-bytebank a:hover {
    color: #000;
  }

  .navbar-nav > li {
    margin-right: 15px;
  }
}
</style>
